import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Full-Stack Developer",
      desc: "I design and develop complete web applications from frontend to backend using modern technologies like React, Node.js, and MongoDB. I focus on performance, scalability, and user experience.",
      icon: "fas fa-laptop-code",
    },
    {
      name: "Frontend Development",
      desc: "Crafting responsive and interactive user interfaces using modern technologies like React, HTML, CSS, and JavaScript.",
      icon: "fas fa-code",
    },
    {
      name: "Backend Development",
      desc: "Building robust server-side logic, RESTful APIs, and integrating databases using Node.js, Express, and MongoDB/MySQL.",
      icon: "fas fa-server",
    },
    {
      name: "Database Design",
      desc: "Designing and managing efficient, secure, and scalable database structures tailored to project needs.",
      icon: "fas fa-database",
    },
    {
      name: "Web Design",
      desc: "I create clean, responsive, and user-friendly website layouts that bring your brand to life and deliver a seamless user experience across all devices.",
      icon: "fas fa-desktop",
    },

    {
      name: "Video Editing",
      desc: "I create professional-quality videos for social media, YouTube, or business promotion using modern editing tools to enhance visuals, audio, and storytelling.",
      icon: "fas fa-video",
    },
    {
      name: "Adobe Photoshop",
      desc: "I design high-quality graphics, social media content, banners, and photo edits using Adobe Photoshop to elevate your brand’s visual identity.",
      icon: "fas fa-image",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
